export default __webpack_public_path__ + "static/data-about-screenshot-3--mobile-cbb4f3f2d89ad92f370664a2921f9774.webp";